import React, { useState, useRef, useEffect } from "react";
import { FileText, X } from "lucide-react";

const FloatingPanel = ({
  children,
  onClose,
  title = "Note de rendez-vous",
}) => {
  const panelRef = useRef(null);
  const [position, setPosition] = useState({ x: 100, y: 100 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    setDragging(true);
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  const handleMouseMove = (e) => {
    if (dragging) {
      setPosition({
        x: e.clientX - offset.x,
        y: e.clientY - offset.y,
      });
    }
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  useEffect(() => {
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  });

  return (
    <div
      ref={panelRef}
      className="fixed w-[600px] bg-white rounded-2xl shadow-2xl z-[10000] overflow-hidden border border-[#840040]"
      style={{ top: position.y, left: position.x }}
    >
      {/* Header reproduit du composant RDV */}
      <div
        onMouseDown={handleMouseDown}
        className="flex items-center justify-between px-5 py-4 bg-white border-b cursor-move"
      >
        <div className="flex items-center gap-3">
          <div className="bg-[#840040]/10 p-3 rounded-xl">
            <FileText className="text-[#840040]" size={24} />
          </div>

          <div>
            <h1 className="text-lg font-bold text-gray-800 leading-tight">
              {title}
            </h1>
            <p className="text-gray-500 text-xs">
              Dictée vocale + résumé automatique
            </p>
          </div>
        </div>

        <button
          onClick={onClose}
          className="p-2 rounded-lg hover:bg-gray-100 transition"
        >
          <X size={18} className="text-gray-600" />
        </button>
      </div>

      {/* Content */}
      <div className="p-3 overflow-y-auto max-h-[80vh]">{children}</div>
    </div>
  );
};

export default FloatingPanel;
